import React, { useEffect, useRef, useState } from 'react'
import {
  Button,
  Col,
  Table,
  Form,
  ButtonToolbar,
  OverlayTrigger,
  Tooltip,
  Image,
  InputGroup
} from 'react-bootstrap'
import NavTitle from '../../../nav-title'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { getFactionsAPI } from '../../../../services/factions'
import {
  BsChevronLeft,
  BsChevronRight,
  BsPlusLg,
  BsSearch
} from 'react-icons/bs'
import AddDepartment from './add'
import EditDepartment from './edit'
import { PIM_ORG_DEPARTMENT } from '../../../../router/routes'
import { PAGE_SETTING } from '../../../../router/routes'
import { useDebounce } from '@react-hook/debounce'
import TextNavTitle from '../../../TextNavTitle'
import detailImg from '../../../../images/Detail.svg'
import editImg from '../../../../images/Edit.svg'
import CardCustom from '../../../custom/card-custom'
import useThaiInput from '../../../../helper/input-fix-th'
import useEngInput from '../../../../helper/input-fix-en'
import useNumberInput from '../../../../helper/input-fix-num'
import TableSkeletonBody from '../../../custom/TableSkeletonBody'

export default function Index() {
  let [searchParams, setSearchParams] = useSearchParams()
  const orgId = searchParams.get('orgId')
  const divisionId = searchParams.get('divisionId')
  const divisionName = searchParams.get('nameGroup')
  const param = { orgId, divisionId }

  const [showCreate, setShowCreate] = useState(false)
  const [showEdit, setShowEdit] = useState(false)

  const [detailTable, setDetailTable] = useState()
  const [isSave, setIsSave] = useState(false)
  const navigate = useNavigate()
  const [isRefresh, setIsRefresh] = useState(false)
  const [isPopupVisible, setIsPopupVisible] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  const [dataTable, setdataTable] = useState([])
  const [input, setInput] = useDebounce('', 1000)

  const inputRef = useRef(null)
  const handleKeyDownTH = useThaiInput(inputRef)
  const handleKeyDownEN = useEngInput(inputRef)
  const handleKeyDownNum = useNumberInput(inputRef)

  useEffect(() => {
    getDepartments()
    setIsRefresh(false)
  }, [isRefresh, input])

  useEffect(() => {
    if (!orgId && !divisionId) {
      return
    } else {
    }
  }, [input])

  const getDepartments = async () => {
    setIsLoading(true)
    const result = await getFactionsAPI({
      ...param,
      searchs: input
    })
    setIsLoading(false)

    if (!result) return
    if (result.status) {
      setdataTable(result.result)
    }
  }

  const handleEditButtonClick = () => {
    setShowEdit(true)
  }

  const handleClick = (d) => {
    navigate(
      `${PIM_ORG_DEPARTMENT}?orgId=${orgId}&divisionId=${divisionId}&nameGroup=${divisionName}&factionId=${d.id}&nameDepartment=${d.faction_en}`
    )
  }
  return (
    <div>
      <NavTitle>
        <TextNavTitle>
          <Link
            className="link"
            style={{ color: '#7A7A7A' }}
            to={`${PAGE_SETTING}?orgId=${orgId}&divisionId=${divisionId}&nameGroup=${divisionName}`}
          >
            <BsChevronLeft /> Division
          </Link>
        </TextNavTitle>
      </NavTitle>
      <p className="fw-normal text-secondary ">
        <Link
          className="link text-secondary"
          to={`${PAGE_SETTING}?orgId=${orgId}&divisionId=${divisionId}&nameGroup=${divisionName}`}
        >
          <Link
            className="link text-secondary "
            to={`${PAGE_SETTING}?orgId=${orgId}`}
          >
            Group:
          </Link>

          {` ${divisionName}`}
        </Link>{' '}
        <span className="link" style={{ color: '#C7C7C7' }}>
          <BsChevronRight /> Division{' '}
        </span>
      </p>
      <CardCustom className="h-full" border="0">
        <div className="p-3 ">
          <Col
            xl={12}
            className="my-auto d-flex gap-3 justify-content-between"
            style={{ flexWrap: 'wrap' }}
          >
            <label
              className=" my-auto fw-bold"
              style={{
                fontSize: '14px'
              }}
            >
              Total: {dataTable.length?.toLocaleString()}
            </label>
            <div className="d-flex justify-content-end gap-2 ">
              <span style={{ minWidth: '400px' }}>
                <InputGroup>
                  <InputGroup.Text className="bg-white border-end-0  text-muted">
                    <BsSearch />
                  </InputGroup.Text>
                  <Form.Control
                    className="border-start-0 ps-0 placeholder-text"
                    placeholder="Division/ Division EN/ Division TH"
                    onChange={(e) => setInput(e.target.value)}
                  />{' '}
                </InputGroup>
              </span>
              <span>
                <Button
                  className="btn btn-primary "
                  onClick={() => setShowCreate(true)}
                  size="lg"
                  style={{
                    minWidth: '150px'
                  }}
                >
                  <BsPlusLg /> Add Division
                </Button>
              </span>
            </div>
          </Col>
        </div>

        <Col xl={12}>
          <Table hover>
            <thead
              className="bg-hrms text-white font-title-table"
              style={{ position: 'sticky', top: '0px' }}
            >
              <tr>
                <th className="fw-normal">#</th>
                <th className="fw-normal">Division</th>
                <th className="fw-normal">Division EN</th>
                <th className="fw-normal">Division TH</th>
                <th className="fw-normal text-center">Count of Employee</th>
                <th className="fw-normal text-center" style={{ width: '6rem' }}>
                  {' '}
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <TableSkeletonBody colSpan={6} rowSpan={10} />
              ) : dataTable.length > 0 ? (
                dataTable.map((d, i) => (
                  <tr key={i} className="fw-light font-small-2">
                    <td className="font-small-2">{i + 1}</td>
                    <td className="font-small-2">{d.faction}</td>
                    <td className="font-small-2">{d.faction_en}</td>
                    <td className="font-small-2">{d.faction_th}</td>
                    <td className="font-small-2 text-center">{d.count_emp}</td>
                    <td className="font-small-2 text-center ">
                      <span className="d-flex justify-content-center">
                        <ButtonToolbar>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id="tooltip-detail">Detail</Tooltip>
                            }
                          >
                            <Button
                              variant="btn btn-outline-primary"
                              className="border-0 d-flex justify-content-center"
                              size="sm"
                              style={{
                                width: '32px',
                                height: '32px'
                              }}
                              onClick={() => {
                                handleClick(d)
                              }}
                            >
                              <Image
                                src={detailImg}
                                style={{
                                  width: '20px'
                                }}
                              />
                            </Button>
                          </OverlayTrigger>
                        </ButtonToolbar>
                        <ButtonToolbar>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id="tooltip-detail">Edit</Tooltip>
                            }
                          >
                            <Button
                              variant="btn btn-outline-primary"
                              className="border-0 d-flex justify-content-center"
                              size="sm"
                              style={{
                                width: '32px',
                                height: '32px'
                              }}
                              onClick={() => {
                                setDetailTable(d)
                                handleEditButtonClick()
                              }}
                            >
                              <Image
                                src={editImg}
                                style={{
                                  width: '20px'
                                }}
                              />
                            </Button>
                          </OverlayTrigger>
                        </ButtonToolbar>
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="fw-light ">
                  <td className="font-small-2 text-center" colSpan={6}>
                    - No data -
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Col>
      </CardCustom>

      {showEdit && (
        <EditDepartment
          setIsRefresh={setIsRefresh}
          isRefresh={isRefresh}
          detail={detailTable}
          divisionId={divisionId}
          orgId={orgId}
          setIsSave={setIsSave}
          showCreate={showEdit}
          isSave={isSave}
          fnGetData={getDepartments}
          setShowCreate={setShowEdit}
          handleKeyDownTH={handleKeyDownTH}
          handleKeyDownEN={handleKeyDownEN}
          handleKeyDownNum={handleKeyDownNum}
        />
      )}
      {showCreate && (
        <AddDepartment
          setIsRefresh={setIsRefresh}
          isRefresh={isRefresh}
          setIsPopupVisible={setIsPopupVisible}
          isPopupVisible={isPopupVisible}
          orgId={orgId}
          param={{ orgId, divisionId }}
          setIsSave={setIsSave}
          showCreate={showCreate}
          isSave={isSave}
          fnGetData={getDepartments}
          setShowCreate={setShowCreate}
          handleKeyDownTH={handleKeyDownTH}
          handleKeyDownEN={handleKeyDownEN}
          handleKeyDownNum={handleKeyDownNum}
        />
      )}
    </div>
  )
}
